<template>
    <v-app>
        <header-card-public current_page="login"></header-card-public>
        <v-content class="bg-container">
            <v-layout fill-height row wrap>
                <!-- Left/top Side: Ads -->
                <v-flex v-if="!isMobile" xs12 sm6 class="ads-section">
                    <div class="ads-bg">
                        <public-notifications></public-notifications>
                    </div>
                </v-flex>

                <!-- Right/bottom Side: Welcome Card -->
                <v-flex xs12 sm6 :class="welcomeSectionClass">
                    <v-layout fill-height align-center justify-center>
                        <div class="login-container">
                            <v-card class="mx-auto login-card" max-width="450">
                                <v-form @submit.prevent="executeRecaptcha" ref="formPasswordRecovery">
                                    <v-card-text> 
                                        <h3 class="text-xs-center">Password Reset</h3>
                                        <v-alert v-if="error" :value="true" color="error" icon="error" outline >
                                            {{ errorMessage }}
                                        </v-alert>          
                                        <v-layout row wrap> 
                                            <v-flex xs12 style="padding:10px;margin-top:10px;">
                                                <v-text-field 
                                                    label="Enter your registered email" 
                                                    v-model="email" 
                                                    :rules="[rules.required, rules.email]" 
                                                    :disabled="disabled"
                                                    @keyup="error=false"
                                                    >
                                                </v-text-field>  
                                            </v-flex>
                                        </v-layout> 
                                    </v-card-text>  
                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn dark :color="welcomeButtonColor" type="submit" :loading="loading">Reset Password</v-btn>
                                        <v-btn @click="$router.go(-1)" :disabled="disabled" >Cancel</v-btn>
                                    </v-card-actions>
                                </v-form> 
                            </v-card>
                        </div>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-content>

        <v-dialog v-model="dialog" width="500" persistent>                 
            <v-card>
                <v-card-title primary-title>
                    <h3>Password Reset</h3>
                </v-card-title>
                <v-card-text>
                    Password reset completed successfully. Please check your email for the temporary password. If the email doesn't appear in your inbox, kindly review your Spam folder.
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn dark color="#1976D2" @click="login()">Ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <recaptcha ref="recaptcha" @verify="submitReCaptcha"></recaptcha>
    </v-app>
</template>
<script>

import '@/assets/css/public.css'
import '@/assets/css/season.css'
import userApi from '@/api/user.js'
import Recaptcha from '@/components/ReCaptcha.vue'
import publicPages from '@/helpers/public-pages.js'

export default {
    name: 'PasswordRecovery',
    metaInfo: {
        title: 'Password Recovery',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Enter registered email then click Continue. If successfull, temporary password will be sent to email.' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        Recaptcha,
        'header-card-public': () => import('@/components/Common/HeaderPublic'),
        'footer-card': () => import('@/components/Common/Footer'),
        'public-notifications': () => import('@/components/PublicNotifications/PublicNotifications'),
    },
    data () {
        return {
        dialog: false,
        disabled: false,
        company_name: '',
        loading: false,
        email: '',  
        firstName: '',
        lastName: '',
        error: false,  
        errorMessage: '',
        pass1: '',  //TODO validation for strong password
        pass2: '',
        show1: false,
        show2: false,
        title: 'Preliminary report',        
        drawer: false,
        rules: {
            required: value => !!value || 'Required.',
            min: v => v.length >= 8 || 'Min 8 characters',
            counter: value => value.length <= 20 || 'Max 20 characters',
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'Invalid e-mail.'
            }
        },
        recaptchaResponse: null,
        }
    },
    methods: {
        login() {
            this.dialog = false
            this.$router.push('/Login')
        },
        submitReCaptcha(response) {
            this.recaptchaResponse = response
            this.resetPassword()
        },       
        executeRecaptcha () {
            // execute the recaptcha widget
            if (this.$refs.formPasswordRecovery.validate()) {
                this.loading = true
                this.disabled = true

                this.$refs.recaptcha.execute()
            }
        },
        clear() {
            this.$refs.formPasswordRecovery.reset()
            this.loading = false
            this.error = false
        },
        async resetPassword() {
            try{
                if (this.$refs.formPasswordRecovery.validate()) {
                    this.loading = true
                    const response = await userApi.resetPassword(this.email, this.recaptchaResponse)

                if ((response) && response.status == 200) {
                    this.loading = false
                    //console.log(JSON.stringify(response.data))

                    if (response.data.success) {
                        this.dialog = true
                    }else{
                        this.error = true
                        this.disabled = false
                        this.errorMessage = response.data.message
                    }
                }
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
                this.loading = false
            }
        }
    },
    mounted() {
        this.$refs.formPasswordRecovery.reset()
    },
    computed: {
        notthesamepassword: function() {
            return this.pass1!=this.pass2
        },
        seasonDetails() {
            return publicPages.getSeasonDetails(this.$route.query.action, this.isMobile);
        },
        welcomeSectionClass() {
            return this.seasonDetails.className;
        },
        welcomeButtonColor() {
            return this.seasonDetails.buttonColor;
        },
    }
}
</script>